/**
 * SearchResults component.
 */
import Content from '@components/elements/search/searchContent';
import Description from '@components/elements/search/searchDescription';
import Event from '@shared/classes/event';
import MainContext from '@shared/components/utils/context/mainContext';
import Message from '@components/atoms/text/searchMessage';
import Rail from '@shared/classes/rail';
import useMain from '../../templates/main/lib/useMain';
import { selectMainAsset } from '@shared/store/slices/main.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect } from 'react';

/**
 * SearchResults component props.
 */
interface Props {
  rails: Rail[];
  message: string;
  searching: boolean;
  setBackground: (background: string) => void;
}

export default function SearchResults({
  rails,
  message,
  searching,
  setBackground,
}: Props) {
  const asset = useAppSelector(selectMainAsset) as Event;
  const context = useMain({ rails, flags: { complete: rails.length > 0 } });

  useEffect(() => {
    setBackground(asset?.background || '');
  }, [asset?.background]);

  return (
    <MainContext.Provider value={context}>
      {!searching ? <Content /> : <></>}
      <Description />
      {message ? <Message searching={searching}>{message}</Message> : null}
    </MainContext.Provider>
  );
}
